import { Box, Container, Divider, Link, Stack, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router';
import { BrandLogo } from '@/components/brand/BrandLogo';
import { FaiscaCredito } from '@/components/brand/FaiscaCredito';
import { useTenant } from '@/tenant/useTenant';

/** Footer of the brand site (home and guides). */
export function LandingFooter() {
  const { config } = useTenant();
  const marketplace = config.marketplaceUrl ?? null;
  return (
    <Box
      component="footer"
      sx={(theme) => ({
        borderTop: `1px solid ${theme.vars.palette.divider}`,
        bgcolor: theme.vars.palette.background.paper,
      })}
    >
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          spacing={2}
          sx={{ justifyContent: 'space-between', alignItems: { sm: 'center' } }}
        >
          <BrandLogo size="small" />
          <Stack direction="row" spacing={2.5} useFlexGap sx={{ flexWrap: 'wrap' }}>
            <Link component={RouterLink} to="/guias" color="inherit">
              Guias para personais
            </Link>
            {marketplace && (
              <Link href={marketplace} color="inherit">
                Encontrar personal
              </Link>
            )}
            <Link href="/privacidade" color="inherit">
              Privacidade
            </Link>
            <Link href="/termos" color="inherit">
              Termos de uso
            </Link>
          </Stack>
        </Stack>
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 2 }}>
          © {new Date().getFullYear()} {config.platformName}
        </Typography>
        <Divider sx={{ mt: 3 }} />
        <Box sx={{ display: 'flex', justifyContent: 'center', pt: 3 }}>
          <FaiscaCredito />
        </Box>
      </Container>
    </Box>
  );
}
